module.exports = __webpack_public_path__ + "img/Standout.31a15df0.png";